import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { FaStar, FaShareAlt } from "react-icons/fa";
import grp from "../Assets/Group 105.png"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaThumbsUp, FaThumbsDown } from "react-icons/fa";
import { useCart } from "../Context/CartContext";
import { Link } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import ReviewSlider from "./ReviewSlider";
import SimilarProduct from "./SimilarProduct"
import LoginModal from "./LoginPage";

// const getCart = () => JSON.parse(localStorage.getItem("cart")) || [];
// const setCart = (cart) =>
//   localStorage.setItem("cart", JSON.stringify(cart));

export default function ProductDetail() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { token, user } = useAuth();


  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);
  const [openLogin, setOpenLogin] = useState(false);

  useEffect(() => {
    const stateProduct = location.state?.product;
    console.log(stateProduct)
    if (stateProduct) {
      setProduct(stateProduct);
      setLoading(false);
    } else {
      fetchProduct();
    }
  }, [id]);


  const { addToCart } = useCart();

  const fetchProduct = async () => {
    try {
      const res = await fetch(
        `https://mediapi.onlinepharmaque.in/api/v1/getAllProduct/${id}`
      );
      const data = await res.json();
      if (data.success) setProduct(data.result);
    } catch {
      toast.error("Product load failed");
    } finally {
      setLoading(false);
    }
  };
  // const handleAddToCart = () => {
  //   const cart = getCart();

  //   const newItem = {
  //     id: product._id,
  //     name: product.pName,
  //     price: product.price,
  //     img: product.pImg[0],
  //     qty: 1,
  //     rating: product.rating || 4.9,
  //     reviews: product.reviews || 7,
  //     brand: product.brand || "ALKEM",
  //     description: product.description || "",
  //   };

  //   // check if already exists
  //   const existingIndex = cart.findIndex(
  //     (item) => item.id === product._id
  //   );

  //   if (existingIndex > -1) {
  //     cart[existingIndex].qty += 1;
  //     toast.info("Quantity increased in cart");
  //   } else {
  //     cart.push(newItem);
  //     toast.success("Added to cart");
  //   }

  //   setCart(cart);
  // };


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const checkLogin = () => {
    if (!token) {
      toast.error("Please login first ❗");

      setOpenLogin(true); // ✅ modal open

      return false;
    }
    return true;
  };


  const handleAddToCart = () => {
    if (!checkLogin()) return;

    addToCart(product);
    toast.success("Added to cart ✅");
  };

  const handleBuyNow = () => {
    if (!checkLogin()) return;

    addToCart(product);
    navigate("/cart");
  };

  const handleShare = async () => {
    const shareData = {
      title: product?.pName,
      text: product?.details,
      url: window.location.href,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);   // mobile share popup
      } else {
        await navigator.clipboard.writeText(window.location.href); // desktop fallback
        alert("Link copied to clipboard ✅");
      }
    } catch (err) {
      console.log("Share cancelled", err);
    }
  };


  if (loading) return <div className="p-10 text-center">Loading...</div>;
  if (!product) return <div>Product not found</div>;

  return (
    <div className="min-h-screen bg-white">
      {/* Breadcrumb */}
      <div className="max-w-7xl mx-auto px-4 py-3 text-xs sm:text-sm text-gray-500">
        <Link to="/" className="hover:text-black">Home</Link> &gt;{" "}

        <Link to="/medicines" className="hover:text-black">Medicines</Link> &gt;{" "}

        <span className="text-black">{product.pName}</span>
      </div>

      {/* Main */}
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-12 gap-8 ">

        {/* IMAGE SECTION */}
        <div className="lg:col-span-5 flex justify-center">
          <div className="w-full max-w-[435px]">

            {/* Main Image */}
            <div className="aspect-square border border-gray-300 rounded-xl flex items-center justify-center">
              <img
                src={`https://mediapi.onlinepharmaque.in/uploads/${product.pImg[activeIndex]}`}
                className="w-[70%] h-[70%] object-contain"
                alt=""
              />
              <div className="flex justify-center gap-2 mt-3 overflow-x-auto">
                {product.pImg.map((img, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveIndex(i)}
                    className={`w-[52px] h-[52px] flex-shrink-0 rounded border
                    ${activeIndex === i
                        ? "border-[#187685]"
                        : "border-black/10"
                      }`}

                  >
                    <img
                      src={`https://mediapi.onlinepharmaque.in/uploads/${img}`}
                      className="w-full h-full object-contain p-1"
                      alt=""
                    />
                  </button>
                ))}
              </div>
            </div>

            {/* Thumbnails */}

          </div>
        </div>

        {/* PRODUCT INFO */}
        <div className="lg:col-span-5">
          <div className="flex justify-between items-start">
            <h1 className="text-lg sm:text-xl lg:text-[25px] font-medium">
              {product.pName}
            </h1>
            <FaShareAlt
              onClick={handleShare}
              className="text-gray-600 mt-1 cursor-pointer"
            />

          </div>



          {/* Price */}
          <div className="mt-4">
            <p className="text-sm line-through text-gray-400">
              MRP ₹{product.discountPrice}
            </p>

            <div className="flex items-center gap-3">
              <span className="text-2xl sm:text-3xl font-semibold text-[#187685]">
                ₹{product.price}
              </span>

              <span className="bg-[#F88E21] text-white text-xs px-2 py-1 rounded">
                {product.offper}OFF
              </span>
              <div className="flex items-center gap-1 px-3 py-1 border border-[#187685] rounded-full">
                <span className="text-sm">{product.ratestar}</span>
                <FaStar className="text-yellow-400 text-sm" />
              </div>

            </div>
          </div>

          <div className="mt-6 border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm">

            {/* Header */}
            <div className="bg-gray-50 px-2 py-1 border-b">
              <h2 className="text-lg font-semibold text-gray-800">
                Product Details
              </h2>
            </div>

            {/* Content */}
            <div>
              {[
                { label: "Brand", value: product.brand },
                { label: "Model Name", value: product.pName },
                { label: "Description", value: product.details },
                { label: "Manufacturer", value: product.manufacturer },
                { label: "Stock", value: product.stock },
              ].map((item, i) => (
                <div
                  key={i}
                  className={`grid grid-cols-2 px-4 py-1 items-start border-b last:border-0 transition
        ${i % 2 === 0 ? "bg-white" : "bg-gray-50"}
        hover:bg-gray-100`}
                >
                  {/* Label */}
                  <p className="text-gray-500 text-sm">
                    {item.label}
                  </p>

                  {/* Value */}
                  <p className="text-gray-800 text-sm font-medium leading-relaxed">
                    {item.label === "Stock" ? (
                      <span
                        className={`px-2 py-1 rounded text-xs font-semibold 
              ${item.value > 0
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"}`}
                      >
                        {item.value > 0 ? `${item.value} In Stock` : "Out of Stock"}
                      </span>
                    ) : (
                      item.value || "-"
                    )}
                  </p>
                </div>
              ))}
            </div>

          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 mt-6">
            <button onClick={handleAddToCart} className="h-[48px] w-full sm:w-[160px] bg-[#187685] text-white rounded-full font-semibold">
              Buy Now
            </button>

            <button
              onClick={handleAddToCart}
              className="h-[48px] w-full sm:w-[160px] border border-gray-400 text-gray-500 rounded-full font-semibold"
            >
              Add to Cart
            </button>
          </div>
        </div>
      </div>

      <SimilarProduct />


      <ReviewSlider product={product} />

      <ToastContainer autoClose={2000} />
      {openLogin && (
        <LoginModal onClose={() => setOpenLogin(false)} />
      )}
    </div>
  );
}
